<!-- 注册 -->
<template>
  <div class="login-wrap">
    <div class="login">
      <!-- <img src="../../assets/img/bg.png" /> -->
      <div class="login-right">
          <img class="logo" src="../../assets/img/logo.png" />
          <h3 style="text-align: center;margin-bottom: 30px;">海量学院</h3>
          <div class="e-form">
            <!-- 验证码登录 -->
            <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="username">
                <el-input
                  placeholder="请输入用户名"
                  v-model="ruleForm.username">
                  <i slot="prefix" class="el-input__icon el-icon-user"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="email">
                <el-input
                  placeholder="请输入邮箱"
                  v-model="ruleForm.email">
                  <i slot="prefix" class="el-input__icon el-icon-s-cooperation"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="mobile">
                <el-input
                  placeholder="请输入手机号码"
                  type="number"
                  v-model="ruleForm.mobile"
                  maxlength="11">
                  <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="checkCode" class="code">
                <el-input
                  placeholder="请输入验证码"
                  v-model="ruleForm.checkCode">
                  <i slot="prefix" class="el-input__icon el-icon-bell"></i>
                </el-input>
                <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loadingl" @click="submitCode" :disabled="countdown > 0"> {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}</el-button>
              </el-form-item>

              <el-form-item prop="password">
                <el-input
                  placeholder="设置6-20位登录密码"
                  type="password"
                  v-model="ruleForm.password">
                  <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="pwd">
                <el-input
                  placeholder="请再次输入登录密码"
                  type="password"
                  v-model="ruleForm.pwd">
                  <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
              </el-form-item>
              <div class="checked">
                <el-checkbox size="mini" text-color="#ff821c" fill="#ff821c" v-model="checked">我已阅读并同意</el-checkbox>
                <span class="checkbox-span" @click="commonText('yhxy')">《海量数据学院用户服务协议》</span>
                <span class="checkbox-span" @click="commonText('yszc')">《海量数据学院用户隐私政策》</span>
              </div>
              <el-form-item class="btttom">
                <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loading" @click="submitForm('ruleForm')">点击注册</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="tip">
            <p>已有账户，<span @click="submitLogin">立即登录</span></p>
          </div>
      </div>
    </div>
  </div>
    
</template>
<script type="text/ecmascript-6">
import { register,getPhoneCheckCode } from '../../api/userMG'
import md5 from 'js-md5';
import axios from 'axios';
export default {
  name: 'login',
  data() {
    var password = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.pwd !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var pwd = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      ruleForm:{
        username:'',
        email:'',
        mobile:'',
        checkCode:'',
        password:'',
        pwd:''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        checkCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { validator: password, trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        pwd: [
          { validator: pwd, trigger: 'blur' },
        ],
      },
      checked:false,
      loading:false,
      countdown: 0, // 倒计时秒数
      intervalId: null, // 存储interval的id
      loadingl:false
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    
  },
  computed: {
    api() {
      return this.$store.getters.api;
    }
  },
  // 里面的函数只有调用才会执行
  methods: {
    submitCode(){
      if(!this.ruleForm.mobile){
        this.$message({
          message: '请输入手机',
          type: 'warning'
        });
        return
      }
      let sign = md5(this.ruleForm.mobile+'ZHE_GE_JIE_KOU_YI_JIN_JIA_MI_LE')
      let params = {
        phoneNum:this.ruleForm.mobile,
        sign:sign
      }
      this.loadingl = true;
      getPhoneCheckCode(params).then(res => {
        console.log('验证码',res);
        this.loadingl = false;
        if(res.code==0){
          this.startCountdown(60);
        }
      })
      .catch(err => {
        this.loadingl = false;
        // this.$message.error('菜单加载失败，请稍后再试！')
      })
    },
    startCountdown(seconds) {
      this.countdown = seconds;
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.checked){
            this.$message.error('请阅读并勾选服务协议及隐私政策！')
            return
          }
          this.loading = true
          console.log(this.ruleForm)
          register(this.ruleForm).then(res => {
            console.log('注册',res);
            if(res.code==0){
              this.$message.success('注册成功！')
              this.$router.push({path:'/login/login'})
            }
            this.loading = false
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('注册失败，请稍后再试！')
          })
        
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    commonText(code){
      this.$router.push({path:'/login/text',query: { code: code }})
    },
    submitLogin(){
      this.$router.push({path:'/login/login'})
    }
  }
}
</script>

<style scoped>
  @media (min-width: 1366px) {
    .login { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .login {
      width: 1300px;
    }
  }
  .login-wrap{
  width: 100%;
  background-image: url('../../assets/img/back2.png');
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}
.login{
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-image: url('../../assets/img/bg.png');
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%; */
  height: 400px;
}
.login img{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-right{
  width: 300px;
  padding: 40px 100px;
  background-image: linear-gradient(bottom,#fff,#fff8f2);
  box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
  border-radius: 10px;
}
.login-right .logo{
  width: 140px;
  margin: 0 auto 20px;
}
.option{
  display: flex;
  align-items: center;
  justify-content: center;
}
.option {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.option p{
  width: 50%;
  text-align: center;
  font-size: 13px;
  border-bottom: 3px solid #efefef;
  padding-bottom: 12px;
  cursor: pointer;
}
.option .cur{
  border-bottom: 3px solid #ff821c;
}
.e-form .key{
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}
.e-form .prop{
  color: #ff821c;
  margin-right: 2px;
}
.e-form /deep/ .el-form--label-top .el-form-item__label{
  padding: 0 !important;
} 
.e-form /deep/ .el-button--small{
  width: 100%;
  padding: 12px 0;
}
.code /deep/ .el-button--small{
  width: auto;
  padding: 12px 20px;
}
.tip{
  display: flex;
  align-items: center;
  justify-content: center;
}
.tip p{
  font-size: 11px;
  color: #999999;
}
.tip p span{
  font-size: 11px;
  color: #ff821c;
  cursor: pointer;
}
.code /deep/ .el-form-item__content{
  display: flex;
}
.btttom{
  margin-top: 20px;
}
.el-checkbox__label{
  font-size: 10px;
}
.checked span{
  font-size: 10px;
}
.checked .checkbox-span{
  color: #ff821c;
  cursor: pointer;
}
.checked /deep/ .el-checkbox__label{
  color: #999 !important;
  font-size: 10px;
  padding-left: 6px;
}
.checked /deep/ .is-checked .el-checkbox__inner{
  background-color: #ff821c;
}
.checked /deep/ .el-checkbox__inner{
  width: 12px;
  height: 12px;
  border: 1px solid #ff821c;
  margin-top: 2px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/register.vue